import { render, staticRenderFns } from "./LogoMod.vue?vue&type=template&id=f7176992"
import script from "./LogoMod.vue?vue&type=script&lang=js"
export * from "./LogoMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports